import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MobileMenuComponent} from '@odp/shared/lib/mobile-menu/mobile-menu.component';
import {siteStatusGuard} from '@odp/shared/lib/guards/site-status.guard';
import {LEGACY_REDIRECTS} from './legacy-redirects';
import {COVID19_ROUTES} from './covid19.routes';

const routes: Routes = [
  {
    path: '',
    canActivate: [siteStatusGuard],
    children: [
      {
        path: 'outage',
        loadComponent: () => import('@odp/shared/lib/outage/outage.component').then((m) => m.OutageComponent)
      },
      {
        path: 'rwd',
        loadComponent: () => import('@odp/rwd-training').then((m) => m.RwdTrainingComponent)
      },
      {
        path: 'mpox',
        loadComponent: () => import('./features/monkeypox/monkeypox.component').then((m) => m.MonkeypoxComponent)
      },
      {
        path: 'antiviral-dashboard',
        children: [
          {
            path: 'table',
            loadComponent: () =>
              import('@odp/covid19/components/app-dashboard/app-dashboard-layout/app-dashboard-layout.component').then(
                (m) => m.AppDashboardLayoutComponent
              )
          },
          {
            path: 'heatmap',
            loadComponent: () =>
              import(
                '@odp/covid19/components/app-dashboard/app-dashboard-heatmap/app-dashboard-heatmap.component'
              ).then((m) => m.AppDashboardHeatmapComponent)
          },
          {
            path: '',
            loadComponent: () =>
              import('@odp/covid19/components/app-dashboard/app-dashboard-charts/app-dashboard-charts.component').then(
                (m) => m.AppDashboardChartsComponent
              )
          }
        ]
      },
      {
        path: 'home',
        component: MobileMenuComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./features/homepage/homepage.component').then((m) => m.HomepageComponent)
          }
        ]
      },
      {
        path: 'covid19',
        children: COVID19_ROUTES
      },
      {path: '', redirectTo: 'home', pathMatch: 'full'}
    ]
  },
  ...LEGACY_REDIRECTS
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
